module.exports = __webpack_public_path__ + "img/macos.95812f03.svg";